module.exports = __webpack_public_path__ + "img/1.cd05e34f.webp";